"use client";
import { jsx as e, jsxs as l, Fragment as n } from "react/jsx-runtime";
import { SelectItem as h, SelectItemText as s } from "../../atoms/Select/Select.mjs";
import { Text as c } from "../../atoms/Text/Text.mjs";
import { cn as m } from "../../../utils/utils.mjs";
const g = ({
  className: i,
  icon: r,
  selectItemLabel: t,
  children: a,
  ...d
}) => /* @__PURE__ */ e(
  h,
  {
    className: m(
      "flex items-center gap-2 px-4 py-2 dark:text-neutral-dark-1000 dark:hover:bg-neutral-dark-400 dark:data-[state=checked]:bg-neutral-dark-400 dark:focus:bg-neutral-dark-400",
      i
    ),
    ...d,
    children: t ? /* @__PURE__ */ l(n, { children: [
      /* @__PURE__ */ e("span", { className: "hidden", children: /* @__PURE__ */ e(s, { fontWeight: "regular", children: /* @__PURE__ */ e("span", { children: a }) }) }),
      r && /* @__PURE__ */ e("span", { className: "shrink-0 size-4 [&_path]:fill-white", children: r }),
      /* @__PURE__ */ e(c, { fontWeight: "regular", asChild: !0, children: /* @__PURE__ */ e("span", { children: t }) })
    ] }) : /* @__PURE__ */ l(n, { children: [
      r && /* @__PURE__ */ e("span", { className: "shrink-0 size-4 [&_path]:fill-white", children: r }),
      /* @__PURE__ */ e(s, { fontWeight: "regular", children: /* @__PURE__ */ e("span", { children: a }) })
    ] })
  }
);
export {
  g as MediaSelectItem
};
